export { default } from './BlogBanner';
